import axios from "axios";
import { parse } from "fast-xml-parser";
import store from "../store";
import router from "../router";
// import DeviceUUID from 'device-uuid'

const isTest = localStorage.getItem("test");

const TEST_URL = "https://mw-test.tvcom.uz";
const BASE_URL = isTest ? TEST_URL : "https://mw.tvcom.uz";

function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
    );
}

export const fetchSeoContent = async () => {
    try {
        const res = await axios.get("/api/title");
        return res;
    } catch (error) {
        console.log(error);
        return error;
    }
};

export const setRating = async (vid, rating) => {
    try {
        const res = await axios({
            method: "get",
            url: `${BASE_URL}/tvmiddleware/api/video/rating/set/`,
            params: {
                authkey: localStorage.getItem("token"),
                vid: vid,
                rating: rating,
                client_id: 1,
                api_key: "56JNSqNT",
                device: "android",
            },
        });
        return res;
    } catch (error) {
        console.log(error);
        return error;
    }
};

// FIXME: rere
export const fetchAbonentProfile = async () => {
    try {
        return fetch(
            `${BASE_URL}/phpapi/customer_info.php?authkey=${localStorage.getItem(
                "token"
            )}`
        )
            .then((res) => res.json())
            .catch((e) => console.log(e));
    } catch (error) {
        console.log(error);
        return error;
    }
};

export const getAbonentPhoneNumber = async () => {
    const authkey = localStorage.getItem("token");

    let urlencoded = new URLSearchParams();
    urlencoded.append("authkey", authkey);

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: urlencoded,
        redirect: "follow",
    };

    return fetch(`${BASE_URL}/phpapi/phone.php`, requestOptions)
        .then((response) => response.json())
        .catch((error) => console.log("error", error));
};

export const fetchCinemas = async () => {
    try {
        const res = await axios.post(
            "https://api.tvcom.uz/api/v1.2.0/cinemas",
            {
                headers: {
                    Authorization: "Bearer @j9@LKLKK29782LLL)",
                },
            }
        );

        return res;
    } catch (error) {
        console.log(error);
        return error;
    }
};

export const fetchCustomerBalance = async () => {
    try {
        const { data } = await axios.get(
            `${BASE_URL}/tvmiddleware/api/customer/balance/`,
            {
                params: {
                    authkey: localStorage.getItem("token"),
                    client_id: 1,
                    device: "android",
                },
            }
        );

        return data.balance;
    } catch (error) {
        console.log(error);
        return error;
    }
};

// FIXME:
export const fetchCustomerTariffList = async () => {
    try {
        const { data } = await axios.get(
            `${BASE_URL}/tvmiddleware/api/customer/tariff/list/`,
            {
                params: {
                    authkey: localStorage.getItem("token"),
                    client_id: 1,
                    device: "android",
                },
            }
        );

        return data.tariffs;
    } catch (error) {
        console.log(error);
        return error;
    }
};

//
// LOGIN
export const checkPhoneNumber = async (number) => {
    try {
        const { data } = await axios.get(
            `${BASE_URL}/phpapi/check_phone.php?phone=${number}`
        );

        return data;
    } catch (error) {
        console.log(error);
    }
};

export const login = (abonement, password, phone_number) => {
    // const uuid = new DeviceUUID.DeviceUUID().get();
    const uuid = uuidv4();
    localStorage.setItem("uuid", uuid);
    if (phone_number) {
        return axios({
            method: "GET",
            url: `${BASE_URL}/tvmiddleware/api/login`,
            params: {
                phone_number,
                password,
                client_id: 1,
                api_key: "56JNSqNT",
                device: "browser",
                device_uid: uuid,
                device_serial: uuid + "_device",
                device_model: "browser",
            },
        })
            .then(({ data }) => {
                const { rss } = parse(data);
                return rss;
            })
            .catch((e) => {
                console.warn(e, "login");
            });
    } else {
        return axios({
            method: "GET",
            url: `${BASE_URL}/tvmiddleware/api/login`,
            params: {
                abonement,
                password,
                client_id: 1,
                api_key: "56JNSqNT",
                device: "browser",
                device_uid: uuid,
                device_serial: uuid + "_device",
                device_model: uuid + "_modal",
            },
        })
            .then((e) => {
                const data = parse(e.data);
                return data.rss;
            })
            .catch((e) => {
                console.warn(e, "login");
            });
    }
};

export const restorePassword = (mobile_phone_number, code) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/account/reset_password/`,
        params: {
            client_id: 1,
            api_key: "56JNSqNT",
            mobile_phone_number,
            code: code ? code : null,
        },
    }).then((e) => {
        let data;
        if (typeof e.data === "string") {
            data = parse(e.data).rss;
        } else {
            data = e.data;
        }
        return data;
    });
};

export const registerAbon = async (mobile_phone_number, utm) => {
    // const ip = await axios.post("https://tvcom.uz/api/shpion3");

    const uuidReal = Date.now() + "" + Math.floor(Math.random() * 1000000);

    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0"); // Ensure two-digit day
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = now.getFullYear();
    const formattedDate = `${day}.${month}.${year}`;

    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/account/register/`,
        params: {
            client_id: 1,
            api_key: "56JNSqNT",
            send_sms: 1,
            mobile_phone_number,
            device: "tbrowser",
            comment: `from browser reg ${formattedDate}`,
            device_uid: uuidReal,
            device_model: "browser",
            utm_source: utm?.utm_source ? utm?.utm_source : null,
            utm_campaign: utm?.utm_campaign ? utm?.utm_campaign : null,
        },
    }).then((e) => {
        let data;
        if (typeof e.data === "string") {
            data = parse(e.data).rss;
        } else {
            data = e.data;
        }
        return data;
    });
};

export const reregAbon = async (phone) => {
    return await axios({
        method: "GET",
        url: `${BASE_URL}/phpapi/rereg.php`,
        params: {
            phone,
        },
    })
        .then((e) => {
            return e?.data;
        })
        .catch((e) => {
            console.warn(e, "rereg");
        });
};
export const actorDetail = async (id) => {
    return await axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/actor/detail/`,
        params: {
            aid: id,
            client_id: 1,
            api_key: "56JNSqNT",
            // authkey: localStorage.getItem("token")
        },
    })
        .then((e) => {
            return e?.data;
        })
        .catch((e) => {
            console.warn(e, "actorDetail");
        });
};
// ---//--- LOGIN
//

export const fetchNewSearch = async (params, abort) => {
    try {
        const res = await axios({
            method: "GET",
            url: `https://api.tvcom.uz/api/v1.2.0/search/all?query=${params}`,
            signal: abort?.signal ? abort?.signal : null,
        });
        return res.data;
    } catch (error) {
        console.log(error);
    }
};

export const fetchSearch = async (page = 1, params, abort) => {
    try {
        const res = await axios({
            method: "GET",
            url: `https://api.tvcom.uz/api/v1.2.0/search?query=${params.q}`,
            params: { page, params },
            signal: abort?.signal ? abort?.signal : null,
        });

        return res.data.videos;
    } catch (error) {
        console.log(error);
    }
};
export const fetchSearchSimilar = async (page = 1, params, abort) => {
    try {
        const res = await axios({
            method: "GET",
            url: `https://api.tvcom.uz/api/v1.2.0/search/movies/related?query=${params.q}`,
            params: params,
            signal: abort?.signal ? abort?.signal : null,
        });
        return res.data.data;
    } catch (error) {
        console.log(error);
    }
};

export const getMovies = (isLogin, params, abort) => {
    delete params.genre;

    if (params?.order === "-popularity") {
        params.trend = 1;
        delete params.order;
    }
    const queryParams = new URLSearchParams();

    for (const [key, val] of Object.entries(params)) {
        if (val) queryParams.append(key, val);
    }
    queryParams.append("client_id", 1);
    queryParams.append("api_key", "56JNSqNT");
    queryParams.append("device", "android");

    if (isLogin && localStorage.getItem("token") !== null) {
        queryParams.append("authkey", localStorage.getItem("token"));

        return fetch(
            `${BASE_URL}/tvmiddleware/api/video/list/?${queryParams}`,
            {
                signal: abort,
            }
        )
            .then((res) => res.json())
            .then((data) => data.videos)
            .catch();
    } else {
        return fetch(
            `${BASE_URL}/tvmiddleware/api/noauth/video/list/?${queryParams}`,
            {
                signal: abort,
            }
        )
            .then((res) => res.json())
            .then(({ videos }) => videos)
            .catch();
    }
};

export const getJanres = () => {
    return axios({
        method: "GET",
        url: `https://api.tvcom.uz/api/v1.1.0/genres`,
        headers: { Authorization: "@j9@LKLKK29782LLL)" },
    })
        .then((e) => {
            return e.data.data;
        })
        .catch((e) => {
            console.warn(e, "getJanres");
        });
};

export const changePassword = ({ old_password, new_password }) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/account/password/change`,
        params: {
            authkey: localStorage.getItem("token"),
            client_id: 1,
            api_key: "56JNSqNT",
            device: "browser",
            old_password,
            new_password,
        },
    })
        .then((e) => {
            let data;
            if (typeof e.data === "string") {
                data = parse(e.data).rss;
            } else {
                data = e.data;
            }
            return data;
        })
        .catch((e) => {
            console.warn(e, "getJanres");
        });
};

export const getJanresMovie = () => {
    return axios({
        method: "POST",
        url: `https://api.tvcom.uz/api/genres?pass=@j9@LKLKK29782LLL)`,
    })
        .then((e) => {
            return e.data.message;
        })
        .catch((e) => {
            console.warn(e, "getJanresMovie");
        });
};

export const getPodborka = () => {
    return axios({
        method: "GET",
        url: `https://api.tvcom.uz/api/v1.2.0/constructors?&device=android`,
        headers: {
            Authorization: "Bearer @j9@LKLKK29782LLL)",
        },
    })
        .then((e) => {
            let filtered = e.data.data;
            filtered = filtered.map((item) => {
                item.movies = item.movies.map((i) => {
                    if (
                        i.thumbnail_small &&
                        typeof i.thumbnail_small == "string"
                    ) {
                        i.thumbnail_small = i.thumbnail_small
                            .replace("http:", "https:")
                            .replace(":8180", "");
                    }
                    if (
                        i.screenshot_big &&
                        typeof i.screenshot_big == "string"
                    ) {
                        i.screenshot_big = i.screenshot_big
                            .replace("http:", "https:")
                            .replace(":8180", "");
                    }
                    if (i.thumbnail_big && typeof i.thumbnail_big == "string") {
                        i.thumbnail_big = i.thumbnail_big
                            .replace("http:", "https:")
                            .replace(":8180", "");
                    }
                    return i;
                });

                return item;
            });

            return filtered;
        })
        .catch((e) => {
            console.warn(e, "getPodborka");
        });
};

export const getPodborkaInner = (id, params) => {
    return axios({
        method: "GET",
        url: `https://api.tvcom.uz/api/v1.2.0/constructors/${id}`,
        params: { device: "android", ...params },
        headers: {
            Authorization: "Bearer @j9@LKLKK29782LLL)",
        },
    })
        .then((e) => {
            let filtered = e.data.data;
            return filtered;
        })
        .catch((e) => {
            console.warn(e, "getPodborka");
        });
};

export const getBanner = () => {
    return axios({
        method: "GET",
        url: `https://api.tvcom.uz/api/v1.2.0/banners`,
    })
        .then((e) => {
            return e.data.data;
        })
        .catch((e) => {
            console.warn(e, "getBanner");
        });
};

export const checkToken = (token) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/account/status/`,
        params: {
            authkey: `${token}`,
            client_id: "1",
            device: "browser",
        },
    })
        .then((e) => {
            const data = parse(e.data);
            store.commit("updateConnection", true);
            return data.rss;
        })
        .catch((e) => {
            if (e.message === "Network Error") {
                store.commit("updateConnection", false);
            }
        });
};

export const getTariffs = () => {
    return axios({
        method: "GET",
        url: `https://api.tvcom.uz/api/tariffs`,
        headers: {
            Authorization: "Bearer @j9@LKLKK29782LLL)",
        },
    })
        .then((e) => {
            return e.data.data;
        })
        .catch((e) => {
            console.warn(e, "getTariffs");
        });
};

export const getUserInfo = () => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/customer/info/`,
        params: {
            authkey: localStorage.getItem("token"),
            client_id: 1,
            api_key: "56JNSqNT",
            device: "android",
        },
    }).then((e) => {
        let data;
        if (typeof e.data === "string") {
            data = parse(e.data).rss;
        } else {
            data = e.data;
        }
        return data;
    });
    // .catch(e => {
    //     if (e?.response?.status === 403) {
    //         setTimeout(() => {
    //             localStorage.clear();
    //             router.push({ name: "tv" });
    //         }, 500);
    //     }
    // });
};

export const addViewed = async ({ vid, assetsId, position }) => {
    if (position) {
        return axios({
            method: "GET",
            url: `${BASE_URL}/tvmiddleware/api/content/position/set/`,
            params: {
                authkey: localStorage.getItem("token"),
                content_id: vid,
                asset_id: assetsId,
                position: position.toFixed(0),
                content_type: "video",
                client_id: 1,
                api_key: "56JNSqNT",
                device: "browser",
            },
        })
            .then((e) => {
                return e.data;
            })
            .catch((e) => {
                if (e?.response?.status === 403) {
                }
                console.warn(e, "addViewed");
            });
    }
};

export const checkWorld = async () => {
    return axios({
        method: "GET",
        url: "https://api.tvcom.uz/api/v1.2.0/ip/check",
    })
        .then((e) => {
            return e.data;
        })
        .catch((e) => {
            console.warn(e, "checkWorld");
        });
};

export function getVideoDetail(id, lang) {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/video/detail/`,
        params: {
            authkey: localStorage.getItem("token"),
            vid: id,
            client_id: 1,
            api_key: "56JNSqNT",
            device: "android",
            lang: lang,
            type: "all",
        },
    })
        .then(({ data }) => data)
        .catch((e) => {
            if (e?.response?.status === 403) {
                setTimeout(() => {
                    localStorage.clear();
                    //window.location.reload();
                }, 2000);
            }
            console.warn(e, "getVideoDetail");
        });
}

export const getVideoDetailNoAuth = async (id) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/noauth/video/detail/`,
        params: {
            vid: id,
            client_id: 1,
            api_key: "56JNSqNT",
            device: "android",
        },
    })
        .then((e) => {
            let data;
            if (typeof e.data === "string") {
                data = parse(e.data).rss;
            } else {
                data = e.data;
            }
            return data;
        })
        .catch((e) => {
            console.warn(e, "getVideoDetail");
        });
};

export const getVideoEpisodeList = async (season_id) => {
    try {
        const params = {
            authkey: localStorage.getItem("token"),
            season_id,
            device: "android",
            client_id: 1,
        };

        const { data } = await axios.get(
            `${BASE_URL}/tvmiddleware/api/video/episode/list/`,
            { params }
        );

        return data;
    } catch (error) {
        console.log(error);
    }
};

export const getQrPayme = async (abonement, amount, abortController) => {
    return axios({
        // signal: abortController.signal,
        method: "POST",
        url: `https://api.tvcom.uz/api/set/shpion/pay`,
        data: {
            abonement,
            amount,
        },
    })
        .then((e) => {
            return e.data;
        })
        .catch((e) => {
            console.warn(e, "getQrPayme");
        });
};

export const subscriptionCost = (tariff_id) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/customer/tariff/subscription/cost/`,
        params: {
            authkey: localStorage.getItem("token"),
            client_id: 1,
            api_key: "56JNSqNT",
            tariff_id,
        },
    })
        .then((e) => {
            let data;
            if (typeof e.data === "string") {
                data = parse(e.data).rss;
            } else {
                data = e.data;
            }

            return data;
        })
        .catch((e) => {
            console.warn(e, "subscriptionCost");
            if (e?.response?.status === 403) {
                setTimeout(() => {
                    localStorage.clear();
                    //window.location.reload();
                }, 2000);
            }
        });
};

export const customerListTariff = () => {
    return axios({
        method: "POST",
        url: `https://tvcom.uz/api/tariff/list`,
    })
        .then((res) => res.data.data.tariffs.item)
        .catch((e) => {
            console.warn(e, "customerListTariff");
        });
};

export const tariffListNoAuth = async () => {
    return await axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/noauth/portal/client/tariff/list/`,
        params: {
            authkey: localStorage.getItem("token"),
            api_key: "56JNSqNT",
            client_id: 1,
        },
    })
        .then((res) => res.data.tariffs)
        .catch((e) => {
            console.warn(e, "tariffListNoAuth");
        });
};

export const customerSubscribe = (tariff_id) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/customer/tariff/subscribe/`,
        params: {
            authkey: localStorage.getItem("token"),
            client_id: 1,
            api_key: "56JNSqNT",
            tariff_id,
        },
    })
        .then((e) => {
            let data;
            if (typeof e.data === "string") {
                data = parse(e.data).rss;
            } else {
                data = e.data;
            }
            return data;
        })
        .catch((e) => {
            if (e?.response?.status === 403) {
                setTimeout(() => {
                    localStorage.clear();
                    //window.location.reload();
                }, 2000);
            }
            console.warn(e, "customerSubscribe");
        });
};
export const customerUnsubscribe = (tariff_id) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/customer/tariff/unsubscribe/`,
        params: {
            authkey: localStorage.getItem("token"),
            client_id: 1,
            api_key: "56JNSqNT",
            tariff_id,
        },
    })
        .then((e) => {
            let data;
            if (typeof e.data === "string") {
                data = parse(e.data).rss;
            } else {
                data = e.data;
            }
            return data;
        })
        .catch((e) => {
            console.warn(e, "customerUnsubscribe");
            if (e?.response?.status === 403) {
                setTimeout(() => {
                    localStorage.clear();
                    //window.location.reload();
                }, 2000);
            }
        });
};
export const promoActivate = (code) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/promo/activate/`,
        params: {
            authkey: localStorage.getItem("token"),
            client_id: 1,
            api_key: "56JNSqNT",
            code,
        },
    })
        .then((e) => {
            let data;
            if (typeof e.data === "string") {
                data = parse(e.data).rss;
            } else {
                data = e.data;
            }
            return data;
        })
        .catch((e) => {
            console.warn(e, "promoActivate");
            if (e?.response?.status === 403) {
                setTimeout(() => {
                    localStorage.clear();
                    //window.location.reload();
                }, 2000);
            }
        });
};

export const logoutLogin = () => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/logout/`,
        params: {
            authkey: localStorage.getItem("token"),
            client_id: 1,
            api_key: "56JNSqNT",
        },
    })
        .then((e) => {
            let data;
            if (typeof e.data === "string") {
                data = parse(e.data).rss;
            } else {
                data = e.data;
            }
            return data;
        })
        .catch((e) => {});
};

export const getChannelList = (compact = 1) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/channel/list/`,
        params: {
            authkey: localStorage.getItem("token"),
            client_id: 1,
            api_key: "56JNSqNT",
            compact: compact,
            // clearCache: Date.now(),
            device: "android",
        },
    })
        .then((e) => {
            let data;
            if (typeof e.data === "string") {
                data = parse(e.data).rss;
            } else {
                data = e.data;
            }

            return data;
        })
        .catch((e) => {
            if (e?.response?.status === 403) {
                setTimeout(() => {
                    // localStorage.clear();
                    //window.location.reload();
                    // router.push({ name: "login" });
                }, 2000);
            }
        });
};

export const channelUrl = (cid) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/channel/url/`,
        params: {
            client_id: 1,
            api_key: "56JNSqNT",
            cid,
            authkey: localStorage.getItem("token"),
            redirect: 0,
            device: "android",
        },
    }).then((e) => {
        let data;
        if (typeof e.data === "string") {
            data = parse(e.data).rss;
        } else {
            data = e.data;
        }
        return data;
    });
};

export const favouriteChannel = async (status, cid) => {
    const params = {
        authkey: localStorage.getItem("token"),
        client_id: 1,
        api_key: "56JNSqNT",
    };

    if (status === "like") {
        params.favorite_channel = cid;
    }

    if (status === "dislike") {
        params.unfavorite_channel = cid;
    }

    return await axios
        .get(`${BASE_URL}/tvmiddleware/api/settings/save/`, {
            params,
        })
        .then((e) => {
            let data;
            if (typeof e.data === "string") {
                data = parse(e.data).rss;
            } else {
                data = e.data;
            }
            return data;
        });
};

export const programUrl = (pid, time, cid) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/program/url/`,
        params: {
            client_id: 1,
            api_key: "56JNSqNT",
            pid,
            time,
            authkey: localStorage.getItem("token"),
            cid,
            redirect: 0,
            device: "android",
        },
    })
        .then((e) => {
            let data;
            if (typeof e.data === "string") {
                data = parse(e.data).rss;
            } else {
                data = e.data;
            }
            return data;
        })
        .catch((e) => {
            if (e?.response?.status === 403) {
                setTimeout(() => {
                    //window.location.reload();
                }, 2000);
            }
        });
};

export const categoryList = (lang, isLogin) => {
    if (isLogin) {
        return axios({
            method: "GET",
            url: `${BASE_URL}/tvmiddleware/api/category/list/`,
            params: {
                client_id: 1,
                api_key: "56JNSqNT",
                authkey: localStorage.getItem("token"),
                lang: lang,
            },
        })
            .then((e) => {
                let data;
                if (typeof e.data === "string") {
                    data = parse(e.data).rss;
                } else {
                    data = e.data;
                }
                return data;
            })
            .catch((e) => {
                if (e?.response?.status === 403) {
                    setTimeout(() => {
                        localStorage.clear();
                        //window.location.reload();
                    }, 2000);
                }
            });
    } else {
        return axios({
            method: "GET",
            url: `${BASE_URL}/tvmiddleware/api/noauth/category/list/`,
            params: {
                client_id: 1,
                api_key: "56JNSqNT",
                lang: lang,
            },
        })
            .then((e) => {
                let data;
                if (typeof e.data === "string") {
                    data = parse(e.data).rss;
                } else {
                    data = e.data;
                }
                return data;
            })
            .catch((e) => {
                if (e?.response?.status === 403) {
                    setTimeout(() => {
                        localStorage.clear();
                        //window.location.reload();
                    }, 2000);
                }
            });
    }
};

export const subscriptionList = () => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/customer/tariff/subscription/list/`,
        params: {
            client_id: 1,
            api_key: "56JNSqNT",
            authkey: localStorage.getItem("token"),
            device: "android",
        },
    })
        .then((e) => {
            const response = e.data.subscriptions;
            return response;
        })
        .catch((e) => {
            if (e?.response?.status === 403) {
                setTimeout(() => {
                    localStorage.clear();
                    //window.location.reload();
                }, 2000);
            }
        });
};

export const likeMovie = (vid, is_favorited) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/video/settings/set/`,
        params: {
            client_id: 1,
            api_key: "56JNSqNT",
            authkey: localStorage.getItem("token"),
            vid,
            is_favorited,
        },
    })
        .then((e) => {
            let data;
            if (typeof e.data === "string") {
                data = parse(e.data).rss;
            } else {
                data = e.data;
            }
            return data;
        })
        .catch((e) => {
            if (e?.response?.status === 403) {
                setTimeout(() => {
                    localStorage.clear();
                    //window.location.reload();
                }, 2000);
            }
        });
};

export const getMovieUrl = (vid, vfid) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/video/url/`,
        params: {
            client_id: 1,
            // api_key: "56JNSqNT",
            authkey: localStorage.getItem("token"),
            vid,
            redirect: 0,
            vfid: vfid ? vfid : null,
            device: "browser",
        },
    })
        .then((e) => {
            let data;
            if (typeof e.data === "string") {
                data = parse(e.data).rss;
            } else {
                data = e.data;
            }
            return data;
        })
        .catch((e) => {});
};

export const getRpg = (cid, day_from = 6, day_to = 6) => {
    var time_from = Date.now() - day_from * 24 * 60 * 60 * 1000;
    var time_to = Date.now() + day_to * 24 * 60 * 60 * 1000;
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/program/list/`,
        params: {
            client_id: 1,
            api_key: "56JNSqNT",
            authkey: localStorage.getItem("token"),
            cid,
            device: "android",
            time_to: (time_to / 1000).toFixed(0),
            time_from: (time_from / 1000).toFixed(0),
        },
    })
        .then((e) => {
            let data;
            if (typeof e.data === "string") {
                data = parse(e.data).rss;
            } else {
                data = e.data;
            }
            return data;
        })
        .catch((e) => {
            if (e?.response?.status === 403) {
                setTimeout(() => {
                    // localStorage.clear();
                    //window.location.reload();
                }, 2000);
            }
        });
};

export const getFullchannels = (tariff_id = 56) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/noauth/portal/client/channel/list/?client_id=1&api_key=56JNSqNT`,
        params: {
            tariff_id,
        },
    }).then((e) => {
        return e.data.channels;
    });
};

export const getTariffsByApi = () => {
    return axios({
        method: "GET",
        url: `https://api.tvcom.uz/api/v1.0.0/tariffs`,
        headers: {
            Authorization: "Bearer @j9@LKLKK29782LLL)",
        },
    }).then((e) => {
        return e.data.data;
    });
};

export const GetAllTarrifs = () => {
    return axios({
        method: "GET",
        url: `https://api.tvcom.uz/api/v1.3.0/tariffs`,
        headers: {
            Authorization: "Bearer @j9@LKLKK29782LLL)",
        },
    }).then((e) => {
        return e.data.data;
    });
};

export const getCinema = async () => {
    return await axios
        .get("https://api.tvcom.uz/api/v1.2.0/cinemas", {
            headers: {
                Authorization: "Bearer @j9@LKLKK29782LLL)",
            },
        })
        .then((e) => {
            let data = e.data.data;
            return data;
        })
        .catch((e) => {
            console.warn(e, "getCinema");
        });
};
export const getChannelInfo = async (search) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/channel/list/search/`,
        params: {
            authkey: localStorage.getItem("token"),
            limit: 1,
            client_id: 1,
            search,
            device: "browser",
        },
    })
        .then((e) => {
            if (typeof e?.data == "string") {
                let data = parse(e.data);
                return data.rss.channels.item;
            } else {
                return e.data;
            }
        })
        .catch((e) => {
            console.warn(e, "getChannelInfo");
        });
};

export const getChannelDetail = async (cid, err = () => {}) => {
    return axios({
        method: "GET",
        url: `${BASE_URL}/tvmiddleware/api/channel/detail/`,
        params: {
            api_key: "56JNSqNT",
            client_id: 1,
            authkey: localStorage.getItem("token"),
            device: "android",
            cid,
        },
    })
        .then((e) => {
            if (typeof e?.data == "string") {
                let data = parse(e.data);
                return data.rss;
            } else {
                return e.data;
            }
        })
        .catch((e) => {
            err && err(e);
            console.warn(e, "getChannelInfo");
            if (e?.response?.status === 403) {
                router.push({ name: "login" });
            }
        });
};

export const sendDelateRequest = async (phone, text) => {
    return axios({
        method: "POST",
        url: `https://api.tvcom.uz/api/v1.0.0/sms/send`,
        headers: {
            Authorization: "Bearer @j9@LKLKK29782LLL)",
        },
        data: {
            phone,
            text,
        },
    })
        .then((e) => {})
        .catch((e) => {
            console.warn(e, "getCinema");
        });
};

export const delateAccount = async (abonement) => {
    return axios({
        method: "POST",
        url: `https://api.tvcom.uz/api/v1.0.0/account/delete`,
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    })
        .then((e) => e)
        .catch((e) => {
            console.warn(e, "getCinema");
        });
};

export const getNewsList = async (params) => {
    return axios({
        method: "GET",
        url: `https://api.tvcom.uz/api/v1.1.0/news`,
        params: {
            ...params,
        },
        headers: {
            Authorization: "Bearer @j9@LKLKK29782LLL)",
        },
    })
        .then((e) => {
            return e.data;
        })
        .catch((e) => {
            console.warn(e, "getNewsList");
        });
};
export const getCurrentNews = async (id) => {
    return axios({
        method: "GET",
        url: `https://api.tvcom.uz/api/v1.0.0/news/` + id,
        headers: {
            Authorization: "Bearer @j9@LKLKK29782LLL)",
        },
    })
        .then((e) => {
            return e.data.data;
        })
        .catch((e) => {
            console.warn(e, "getCinema");
        });
};
